import React, { useState } from 'react';
import Login from './Login';
import Signup from './Signup';

const AuthContainer: React.FC = () => {
  const [showSignup, setShowSignup] = useState(false);

  if (showSignup) {
    return (
      <Signup 
        onBack={() => setShowSignup(false)}
      />
    );
  }

  return <Login onShowSignup={() => setShowSignup(true)} />;
};

export default AuthContainer;